"use client";

import {Slider} from "@/components/ui/slider";
import {useEffect, useState} from "react";
import {formatPrice} from "@/utils/format-price";


export interface FinanziamentoProps {
    prezzoAuto: number;
    articolo: any;
    onChangeRate?: (rate: number)  => void;
}

export default function Finanziamento({prezzoAuto, articolo, onChangeRate}: FinanziamentoProps) {

    const [anticipo, setAnticipo] = useState(0);
    const [durata, setDurata] = useState(8);
    const [rata, setRata] = useState(0);
    const [maxAnticipo, setMaxAnticipo] = useState(prezzoAuto - 5000);

    const spesaIstruttoria = 350;
    const impostaBollo = 16;
    const tasso = 8.95;

    const handleDurata = (value: any) => {
        setDurata(value[0]);
    };

    const handleAnticipo = (value: any) => {
        setAnticipo(value[0]);
    };

    const handleAnticipoCommit = (value: any) => {
        setAnticipo(value[0]);
        calcolaRata();
    };

    const handleDurataCommit = (value: any) => {
        setDurata(value[0]);
        calcolaRata();

    };

    const calcolaRata = () => {
        const prezzoFinanziato = (prezzoAuto - anticipo) + spesaIstruttoria + impostaBollo;
        const interessi = tasso / 100 / 12; // Interesse mensile
        const mensilita = durata * 12; // Numero di rate (anni * 12 mesi)
        const costante = Math.pow(1 + interessi, mensilita);
        const rataMensile = (prezzoFinanziato * costante * interessi) / (costante - 1);

        setRata(rataMensile);
    }

    useEffect(() => {
        calcolaRata();
    }, []);



    return (
        <div className="bg-white/40 p-8 max-xl:p-4 rounded-lg">

            <div className="flex gap-x-5 justify-between max-lg:flex-col">


                <div>

                <div id="title" className="mb-9">
                    <h4 className="text-4xl font-bold max-xl:text-3xl max-xl:text-center  mb-3">Oppure
                        calcola la tua
                        rata</h4>
                    <p className="text-2xl max-xl:text-xl max-xl:text-center font-normal">Ricevi un
                        preventivo gratuito,
                        senza impegno e non vincolante.
                    </p>
                </div>

                <div className="mb-9 grid grid-cols-2 max-xl:text-sm text-xl gap-y-4">

                    <div className="flex items-center">
                        <svg className="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                            <path
                                d="M6.8182 11.0795L11.2544 15.793C11.3136 15.8559 11.4137 15.8559 11.4729 15.793L23.4849 3.03027"
                                stroke="#222222" strokeWidth="2"/>
                            <path
                                d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                        </svg>

                        <p>Acquisto a distanza</p>
                    </div>

                    <div className="flex items-center">
                        <svg className="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                            <path
                                d="M6.8182 11.0795L11.2544 15.793C11.3136 15.8559 11.4137 15.8559 11.4729 15.793L23.4849 3.03027"
                                stroke="#222222" strokeWidth="2"/>
                            <path
                                d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                        </svg>

                        <p>Preventivo senza impegno</p>
                    </div>

                    <div className="flex items-center">
                        <svg className="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                            <path
                                d="M6.8182 11.0795L11.2544 15.793C11.3136 15.8559 11.4137 15.8559 11.4729 15.793L23.4849 3.03027"
                                stroke="#222222" strokeWidth="2"/>
                            <path
                                d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                        </svg>

                        <p>Permuta dell’usato</p>
                    </div>

                    <div className="flex items-center">
                        <svg className="mr-2" width="25" height="25" viewBox="0 0 25 25" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12.5" r="12.5" fill="#7E869E" fillOpacity="0.25"/>
                            <path
                                d="M6.8182 11.0795L11.2544 15.793C11.3136 15.8559 11.4137 15.8559 11.4729 15.793L23.4849 3.03027"
                                stroke="#222222" strokeWidth="2"/>
                            <path
                                d="M23.782 10.2714C24.2912 12.8492 23.9023 15.5237 22.6799 17.8497C21.4576 20.1757 19.4755 22.013 17.0637 23.0557C14.6518 24.0985 11.9555 24.2838 9.42366 23.5809C6.89178 22.878 4.67698 21.3292 3.14784 19.1923C1.61871 17.0554 0.867483 14.4593 1.01918 11.8361C1.17088 9.21283 2.21635 6.72063 3.98161 4.77426C5.74687 2.82789 8.12544 1.54474 10.7215 1.13836C13.3175 0.731984 15.9744 1.22689 18.25 2.54071"
                                stroke="#222222" strokeWidth="2" strokeLinecap="round"/>
                        </svg>

                        <p>Spedizione in tutta Italia</p>
                    </div>

                </div>
                </div>

                <div>


                    <div className="my-5 flex flex-col gap-y-2">
                    <div className="flex flex-row justify-between">
                        <p className="text-black text-2xl font-bold">Anticipo</p>
                        <p className="text-black text-2xl font-bold">{formatPrice(anticipo)}</p>
                    </div>
                    <label>
                        <Slider defaultValue={[anticipo]} min={0} max={maxAnticipo} onValueChange={handleAnticipo}
                                onValueCommit={handleAnticipoCommit} step={100}/>
                    </label>

                </div>

                <div className="my-5 flex flex-col gap-y-2">
                    <div className="flex flex-row justify-between">
                        <p className="text-black text-2xl font-bold">Durata</p>
                        <p className="text-black text-2xl font-bold">{durata} {durata == 1 ? 'anno': 'anni'} </p>
                    </div>
                    <label>
                        <Slider defaultValue={[durata]} max={8} min={1} onValueChange={handleDurata}
                                onValueCommit={handleDurataCommit} step={1}/>
                    </label>

                </div>

                    <h4 className="text-black text-7xl max-lg:text-center font-bold max-xl:my-4 max-xl:text-6xl">{formatPrice(rata)}<span
                    className="text-2xl">/ mese</span></h4>
                </div>

            </div>

        </div>
    )

}
